import {
  assignmentRuleReplayResponseSchema,
  assignmentRuleSchema,
  transactionBulkAssignResponseSchema,
  transactionSchema,
  type AssignmentRuleUpdate,
  type Transaction,
  type TransactionAssignInput,
  type TransactionNoteInput,
} from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

export function fetchAssignmentQueue(): Promise<Transaction[]> {
  return apiFetch('/api/assignment-queue', { schema: z.array(transactionSchema) });
}

export function assignTransaction(id: number, input: TransactionAssignInput): Promise<Transaction> {
  return apiFetch(`/api/transactions/${id}/assign`, { method: 'POST', body: input, schema: transactionSchema });
}

export function updateTransactionNote(id: number, input: TransactionNoteInput): Promise<Transaction> {
  return apiFetch(`/api/transactions/${id}/note`, { method: 'PATCH', body: input, schema: transactionSchema });
}

export function assignTransactionsBulk(transactionIds: number[], input: TransactionAssignInput) {
  return apiFetch('/api/transactions/assign-bulk', {
    method: 'POST',
    body: { transactionIds, ...input },
    schema: transactionBulkAssignResponseSchema,
  });
}

export function fetchAssignmentRules() {
  return apiFetch('/api/assignment-rules', { schema: z.array(assignmentRuleSchema) });
}

export function updateAssignmentRule(id: number, input: AssignmentRuleUpdate) {
  return apiFetch(`/api/assignment-rules/${id}`, { method: 'PATCH', body: input, schema: assignmentRuleSchema });
}

export function deleteAssignmentRule(id: number) {
  return apiFetch(`/api/assignment-rules/${id}`, { method: 'DELETE', schema: assignmentRuleSchema });
}

export function replayAssignmentRule(id: number) {
  return apiFetch(`/api/assignment-rules/${id}/replay`, { method: 'POST', schema: assignmentRuleReplayResponseSchema });
}
